import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { faSearch, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-document-search-input',
    templateUrl: './document-search-input.component.html',
    styleUrl: './document-search-input.component.scss',
    standalone: false
})
export class DocumentSearchInputComponent implements OnDestroy {
  public readonly faSearch: IconDefinition = faSearch;
  public searchText: string = '';

  @Output()
  public onSearch: EventEmitter<string> = new EventEmitter<string>();

  ngOnDestroy(): void {
    this.onSearch.complete();
  }

  public search(): void {
    if (this.searchText && this.searchText.trim().length > 0) {
      this.onSearch.emit(this.searchText.trim());
    } else {
      this.onSearch.emit('');
    }
  }

  public clearSearch(): void {
    this.searchText = '';
    this.onSearch.emit('');
  }
}
